import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {withStyles, createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import cookie from 'react-cookies'
import {EasyMiddleware} from "./EasyMiddleware";
import Divider from '@material-ui/core/Divider';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import moment from 'moment'

const theme = createMuiTheme({
    shadows: ['none']
})

const styles = {
    title: {
        fontSize: "1.20rem",
        fontWeight: "600",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "0.77",
        letterSpacing: "-0.5px",
        fontFamily: "Saira",
        textTransform: 'uppercase'
    },

    title_day: {
        "height": "18px",
        "fontFamily": "Saira",
        "fontSize": "0.95rem",
        "fontWeight": "normal",
        "fontStyle": "normal",
        "fontStretch": "semi-condensed",
        "lineHeight": "1.2",
        "letterSpacing": "normal",
        "textAlign": "right",
        "color": "#000000"
    },

    titleContainer: {
        display: "flex",
        justifyContent: "space-between",
    },

    shiftImg: {
        maxWidth: '36px',
        maxHeight: '36px'
    },

    shiftContainer: {
        display: "flex",
        justifyContent: "space-around",
        marginTop: "5px"
    },

    container: {
        minWidth: '140px',
        marginBottom: '20px',
        maxHeight: '150px',
        boxShadow: 'none'
    },

    shift: {
        display: 'flex',
        flexDirection: 'column',
        width: '80px',
        height: '90px',
        alignContent: 'center',
        alignItems: 'center',
        paddingBottom: '10px',
        borderRadius: '6px'
    },

    shiftImgWrapper: {
        width: '90px',
        height: '90px',
        marginBottom: '30%',
        display: "inline-flex",
        alignItems: "flex-end",
        justifyContent: "space-around"
    },

    wageContainer: {
        width: '85%',
        display: 'flex',
        flexWrap: 'nowrap',
        fontFamily: 'Saira Semi Condensed',
        fontWeight: '600',
        fontStyle: 'normal',
        fontStretch: 'semi-condensed',
        lineHeight: 1,
        letterSpacing: '-0.4px',
        textAlign: 'center',
        alignItems: 'flex-end',
        justifyContent: 'space-evenly'
    },

    wage: {
        fontSize: '1.3rem'
    },

    wageHuf: {
        fontSize: '1rem'
    },

    cardContent: {
        margin: '10px',
    },

    accepted: {
        backgroundColor: '#004c45',
        color: '#91d1ba'
    },

    acceptedShiftImg: {
        maxWidth: '80px'
    },

    canceled: {
        color: '#dfdfdf'
    },

    dialogTitle: {
        fontSize: "0.95rem",
        fontWeight: "600",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "1.47",
        letterSpacing: "-0.1px",
        textAlign: "center",
        color: "black",
        fontFamily: 'Saira',
        textTransform: "uppercase",
        padding: '10px 24px 10px'
    },

    dialogImgContent: {
        padding: "10px 0 0 0"
    },

    dialogImg: {
        width: '100%'
    },

    dialogText: {
        textAlign: "center",
        fontFamily: "Saira",
        fontSize: "0.95rem",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "1.2",
        letterSpacing: "-0.3px",
        color: "#000000"
    },

    dialogTextContent: {
        padding: "0 24px 14px"
    },

    dialogActions: {
        display: "flex",
        justifyContent: "space-between",
        padding: "6px 8px",
        borderTop: "solid 1px #e6e6e6",
        margin: "0",
    },

    dialogActionsCenter: {
        display: "flex",
        justifyContent: "center",
        padding: "6px 8px",
        borderTop: "solid 1px #e6e6e6",
        margin: "0",
    },

    acceptButton: {
        color: '#00b1a1',
        width: "100%",
        fontFamily: "Saira"
    },

    cancelButton: {
        color: '#747474',
        width: "100%",
        fontFamily: "Saira"
    },

    noWork: {
        backgroundColor: '#d8d8d8',
        height: "150px"
    },

    noWorkImgWrapper: {
        height: "90px",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column"
    },

    cardText: {
        display: 'flex',
        flexWrap: 'nowrap',
        fontFamily: 'Saira',
        fontWeight: '600',
        fontStyle: 'normal',
        fontStretch: 'semi-condensed',
        lineHeight: 1,
        letterSpacing: '-0.4px',
        textAlign: 'center',
        alignItems: 'flex-end',
        justifyContent: 'space-evenly'
    },

    monthDays: {
        color: '#91d1ba',
        display: "flex",
        // justifyContent: "space-around",
        fontFamily: "Saira",
        padding: "5% 0",
    },

    monthDay: {
        minWidth: '14.5%',
        maxWidth: '14.5%',
        textAlign: "center",
    },

    monthWeek: {
        minHeight: "10%",
        display: "flex",
    },

    monthDivider: {
        margin: "0 -10%",
    },

    monthDayOfWeek: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        "fontFamily": "Saira",
        "fontSize": "0.9rem",
        "fontWeight": "normal",
        "fontStyle": "normal",
        "fontStretch": "semi-condensed",
        "lineHeight": "normal",
        "letterSpacing": "normal",
        "textAlign": "center",
        "color": "#000000",
        padding: "4% 0",
        minWidth: '14.5%',
        maxWidth: '14.5%',
        minHeight: '2.55rem'
    },

    monthContainer: {
        maxHeight: "unset"
    },

    wallHeader: {
        display: "flex",
        justifyContent: "space-between",
        select: {
            color: "red",
        }
    },

    viewSelector: {
        marginBlockStart: "1.2rem",
        marginBlockEnd: "1.5rem",
        marginInlineStart: "0px",
        marginInlineEnd: "0px",
        width: "6rem",
        display: "flex",
        justifyContent: "space-between",
        color: "white"
    },

    leftSelector: {
        border: "white solid 1px",
        padding: "13%",
        borderRadius: "0.4rem 0 0 0.4rem",
        transition: "all .3s linear",
    },

    rightSelector: {
        border: "white solid 1px",
        padding: "13%",
        borderRadius: " 0 0.4rem 0.4rem 0",
        marginRight: "1rem",
        transition: "all .3s linear",
    },

    activeSelector: {
        backgroundColor: "white",
        color: "#73bcaf",
    },

    monthDayText: {
        fontFamily: "Saira",
        fontSize: "0.75rem",
        fontWeight: "600",
        fontStyle: "normal",
        fontStretch: "semi-condensed",
        lineHeight: "normal",
        letterSpacing: "normal",
        textAlign: "center",
        color: "#91d1ba",
    },

    monthToday: {
        borderRadius: "0.6rem",
        background: "#004c45",
        color: "#91d1ba",
    },

    monthCardContent: {
        paddingBottom: '0.7rem !important'
    },
}

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class Wall extends Component {

    constructor(props) {
        super(props)
        this.state = {
            openApplyDialog: false,
            openApplySuccessDialog: false,
            openCancelDialog: false,
            openCancelSuccessDialog: false,
            openErrorDialog: false,
            offerId: null,
            userOfferId: null,
            isLoading: true,
            schedules: {},
            refreshCards: false,
            errorMsg: '',
            hasMoreCards: true,
            nextPageUrl: '/api/feed',
            nextMonthsUrl: '/api/feed/monthly',
            token: cookie.load('apiToken'),
            user: null,
            workdays: {},
            cardView: true,
            months: {},
        }
    }

    componentDidMount() {
        EasyMiddleware.checkResetPassword()
        this.loadMoreCards()
        this.loadMonths()
    }

    loadMoreCards = () => {
        let token = this.state.token

        let url = this.state.nextPageUrl
        axios.get(url, {headers: {Authorization: token}}).then((response) => {
            let responseData = response.data
            let schedules = Object.assign(this.state.schedules, responseData.schedules)
            let workdays = Object.assign(this.state.workdays, responseData.workdays)

            this.setState({schedules: schedules})
            this.setState({workdays: workdays})

            this.setState({user: responseData.user})
            this.setState({nextPageUrl: responseData.pagination.nextPageUrl})
            this.setState({hasMoreCards: responseData.pagination.hasMorePage})
        }).catch(function (error) {
            if (error.response.status === 401) {
                window.postMessage('logout')
            }
        })
    }

    renderDynamicUserCards = (schedules) => {
        const {classes} = this.props
        let cards = []
        let currentMonth

        Object.keys(schedules).map((date) => {
            let scheduleDate = new Date(date)

            let month = new Intl.DateTimeFormat('hu-HU', {year: 'numeric', month: 'long'}).format(scheduleDate)
            if (currentMonth !== month) {
                currentMonth = month
                cards.push(
                    <div>
                        <h3>
                            {currentMonth}
                        </h3>
                    </div>
                )
            }

            cards.push(
                <Card className={classes.container}>
                    <CardContent>
                        <div className={classes.titleContainer}>
                            <Typography className={classes.title} variant="h5" component="h5">
                                {new Intl.DateTimeFormat('hu-HU', {month: 'long', day: 'numeric'}).format(scheduleDate)}
                            </Typography>
                            <Typography className={classes.title_day}>
                                {schedules[date][0].dayName}
                            </Typography>
                        </div>
                        <div className={classes.shiftContainer}>
                            <div className={classNames({
                                    [classes.shift]: true,
                                    [classes.accepted]: schedules[date][0].status === 1,
                                    [classes.canceled]: schedules[date][0].status === 2
                                }
                            )}
                                 onClick={() => {
                                     if (schedules[date][0].status === 0) {
                                         this.handleAcceptDialogOpen(schedules[date][0].offer.offer_id)
                                     } else if (schedules[date][0].status === 1) {
                                         this.handleCancelDialogOpen(schedules[date][0].offer.userAcceptedOffer.id)
                                     }
                                 }}
                            >
                                <div className={classes.shiftImgWrapper}>
                                    <img className={
                                        classNames({
                                            [classes.shiftImg]: schedules[date][0].status !== 1,
                                            [classes.acceptedShiftImg]: schedules[date][0].status === 1,
                                        })}
                                         src={this.getImgUrl(schedules[date][0].status, 1)}
                                    />
                                </div>
                                <div className={classes.wageContainer}>
                                    <div className={classes.wage}>
                                        {schedules[date][0].offer.wage}
                                    </div>
                                    <div className={classes.wageHuf}>
                                        Ft
                                    </div>
                                </div>
                            </div>

                            <div className={classNames({
                                    [classes.shift]: true,
                                    [classes.accepted]: schedules[date][1].status === 1,
                                    [classes.canceled]: schedules[date][1].status === 2
                                }
                            )}>
                                <div className={classes.shiftImgWrapper}>
                                    <img className={
                                        classNames({
                                            [classes.shiftImg]: schedules[date][1].status !== 1,
                                            [classes.acceptedShiftImg]: schedules[date][1].status === 1,
                                        })}
                                         src={this.getImgUrl(schedules[date][1].status, 2)}
                                         onClick={() => {
                                             if (schedules[date][1].status === 0) {
                                                 this.handleAcceptDialogOpen(schedules[date][1].offer.offer_id)
                                             } else if (schedules[date][1].status === 1) {
                                                 this.handleCancelDialogOpen(schedules[date][1].offer.userAcceptedOffer.id)
                                             }
                                         }}
                                    />
                                </div>
                                <div className={classes.wageContainer}>
                                    <div className={classes.wage}>
                                        {schedules[date][1].offer.wage}
                                    </div>
                                    <div className={classes.wageHuf}>
                                        Ft
                                    </div>
                                </div>
                            </div>


                            <div className={classNames({
                                    [classes.shift]: true,
                                    [classes.accepted]: schedules[date][2].status === 1,
                                    [classes.canceled]: schedules[date][2].status === 2
                                }
                            )}>
                                <div className={classes.shiftImgWrapper}>
                                    <img className={
                                        classNames({
                                            [classes.shiftImg]: schedules[date][2].status !== 1,
                                            [classes.acceptedShiftImg]: schedules[date][2].status === 1,
                                        })}
                                         src={this.getImgUrl(schedules[date][2].status, 3)}
                                         onClick={() => {
                                             if (schedules[date][2].status === 0) {
                                                 this.handleAcceptDialogOpen(schedules[date][2].offer.offer_id)
                                             } else if (schedules[date][2].status === 1) {
                                                 this.handleCancelDialogOpen(schedules[date][2].offer.userAcceptedOffer.id)
                                             }
                                         }}
                                    />
                                </div>
                                <div className={classes.wageContainer}>
                                    <div className={classes.wage}>
                                        {schedules[date][2].offer.wage}
                                    </div>
                                    <div className={classes.wageHuf}>
                                        Ft
                                    </div>
                                </div>
                            </div>

                        </div>
                    </CardContent>
                </Card>)
        })

        return cards
    }

    renderFixUserCards = (workdays) => {
        const {classes} = this.props
        let currentMonth
        let cards = []


        Object.keys(workdays).map((date) => {
            let scheduleDate = new Date(date)

            let month = new Intl.DateTimeFormat('hu-HU', {year: 'numeric', month: 'long'}).format(scheduleDate)
            let formatedDate = new Intl.DateTimeFormat('hu-HU', {month: 'long', day: 'numeric'}).format(scheduleDate)
            if (currentMonth !== month) {
                currentMonth = month
                cards.push(
                    <div>
                        <h3>
                            {currentMonth}
                        </h3>
                    </div>
                )
            }

            if (workdays[date].freeDay || workdays[date].sick_leave || workdays[date].leave) {

                let cardText = () => {
                    if (workdays[date].freeDay) return "Pihenőnap"
                    if (workdays[date].leave) return "Szabadság"
                    if (workdays[date].sick_leave) return "Betegszabadság"
                };

                cards.push(
                    <Card className={classNames({[classes.container]: true, [classes.noWork]: true})}>
                        <CardContent>
                            <div className={classes.titleContainer}>
                                <Typography className={classes.title} variant="h5" component="h5">
                                    {formatedDate}
                                </Typography>
                                <Typography className={classes.title_day}>
                                    {workdays[date].dayName}
                                </Typography>
                            </div>
                            <div className={classes.noWorkImgWrapper}>
                                <img src="/images/nowork-illu.svg"/>
                            </div>
                            <div className={classes.cardText}>
                                {cardText()}
                            </div>
                        </CardContent>
                    </Card>)

            } else {
                cards.push(
                    <Card className={classes.container}>
                        <CardContent>
                            <div className={classes.titleContainer}>
                                <Typography className={classes.title} variant="h5" component="h5">
                                    {formatedDate}
                                </Typography>
                                <Typography className={classes.title_day}>
                                    {workdays[date].dayName}
                                </Typography>
                            </div>

                            <div className={classes.shiftContainer}>

                                <div className={classNames({
                                        [classes.shift]: true,
                                        [classes.accepted]: workdays[date].shift === 0,
                                    }
                                )}
                                >
                                    <div className={classes.shiftImgWrapper}>
                                        <img className={
                                            classNames({
                                                [classes.shiftImg]: workdays[date].shift !== 0,
                                                [classes.acceptedShiftImg]: workdays[date].shift === 0,
                                            })}
                                             src={this.getImgUrl(workdays[date].shift === 0 ? 1 : 0, 1)}
                                        />
                                    </div>
                                </div>

                                <div className={classNames({
                                        [classes.shift]: true,
                                        [classes.accepted]: workdays[date].shift === 1,
                                    }
                                )}
                                >
                                    <div className={classes.shiftImgWrapper}>
                                        <img className={
                                            classNames({
                                                [classes.shiftImg]: workdays[date].shift !== 1,
                                                [classes.acceptedShiftImg]: workdays[date].shift === 1,
                                            })}
                                             src={this.getImgUrl(workdays[date].shift === 1 ? 1 : 0, 2)}
                                        />
                                    </div>
                                </div>

                                <div className={classNames({
                                        [classes.shift]: true,
                                        [classes.accepted]: workdays[date].shift === 2,
                                    }
                                )}
                                >
                                    <div className={classes.shiftImgWrapper}>
                                        <img className={
                                            classNames({
                                                [classes.shiftImg]: workdays[date].shift !== 2,
                                                [classes.acceptedShiftImg]: workdays[date].shift === 2,
                                            })}
                                             src={this.getImgUrl(workdays[date].shift === 2 ? 1 : 0, 3)}
                                        />
                                    </div>
                                </div>

                            </div>
                        </CardContent>
                    </Card>)
            }
        })

        return cards
    }

    renderCards = () => {

        const {schedules} = this.state
        const {workdays} = this.state
        const {user} = this.state

        if (schedules.length < 1 || user === null) return


        if (user.user_type === 2) {
            return this.renderFixUserCards(workdays)
        }

        return this.renderDynamicUserCards(schedules)

    }

    getImgUrl = (status, shift) => {
        switch (status) {
            case 0:
                return 'images/icon' + shift + '_green.png'
            case 1:
                return 'images/icon' + shift + '_on.png'
            case 2:
                return 'images/icon' + shift + '_grey.png'
        }
    }

    handleApplyDialogClose = () => {
        this.setState({openApplyDialog: false})
    }

    updateObjects = (schedule, cancel) => {
        const {schedules, months} = this.state

        schedules[schedule.day][schedule.shift] = schedule

        Object.keys(months).map(function (month) {
            if (months[month][schedule.day]) {
                months[month][schedule.day].info = cancel === undefined ? { shift: schedule.shift } : null
            }
        })
    }

    handleApplyDialogConfirm = () => {
        const {offerId, schedules, months} = this.state
        let token = this.state.token

        axios.post(`/api/offer/apply/${offerId}`, {}, {headers: {Authorization: token}}).then((response) => {
            this.updateObjects(response.data.schedule)
            this.handleApplyDialogClose()
            this.handleApplySuccessDialogOpen()
        }).catch((error) => {
            if (error.response.status === 422) {
                this.setState({errorMsg: error.response.data.msg})
            } else if (error.response.status === 401) {
                window.postMessage('logout')
            } else {
                this.setState({errorMsg: 'Hiba a folyamat végrehajtása közben'})
            }
            this.handleApplyDialogClose()
            this.errorDialogToggle()
        })
    }

    handleAcceptDialogOpen = (offerId) => {
        this.setState({openApplyDialog: true, offerId: offerId})
    }

    handleCancelDialogOpen = (userOfferId) => {
        this.setState({openCancelDialog: true, userOfferId: userOfferId})
    }

    handleCancelDialogClose = () => {
        this.setState({openCancelDialog: false})
    }

    handleApplySuccessDialogOpen = () => {
        this.setState({openApplySuccessDialog: true})
    }

    handleApplySuccessDialogClose = () => {
        this.setState({openApplySuccessDialog: false})
    }

    handleCancelDialogConfirm = () => {
        const {userOfferId} = this.state
        let token = this.state.token

        axios.patch(`/api/offer/cancel/${userOfferId}`, {}, {headers: {Authorization: token}})
            .then((response) => {
                this.updateObjects(response.data.schedule, true)
                this.handleCancelDialogClose()
                this.cancelSuccessDialogToggle()
            })
            .catch((error) => {
                if (error.response.status === 422) {
                    this.setState({errorMsg: error.response.data.msg})
                } else if (error.response.status === 401) {
                    window.postMessage('logout')
                }
                else {
                    this.setState({errorMsg: 'Hiba lépett fel a folyamat feldolgozása közben.'})
                }
                this.handleCancelDialogClose()
                this.errorDialogToggle()
            })
    }

    applyOfferDialog = (offerId) => {
        const {classes} = this.props

        return (
            <Dialog
                open={this.state.openApplyDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleApplyDialogClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"

            >
                <DialogContent classes={{root: classes.dialogImgContent}}>
                    <img className={classes.dialogImg} src="images/question_illustration.png"/>
                </DialogContent>

                <DialogTitle id="alert-dialog-slide-title"
                             classes={{root: classes.dialogTitle}}
                             disableTypography={true}>
                    Műszak elfogadása
                </DialogTitle>
                <DialogContent classes={{root: classes.dialogTextContent}}>
                    <DialogContentText id="alert-dialog-slide-description" classes={{root: classes.dialogText}}>
                        Valóban elfogadod ezt a műszakot?
                    </DialogContentText>
                </DialogContent>
                <DialogActions classes={{root: classes.dialogActions}}>
                    <Button onClick={this.handleApplyDialogClose} className={classes.cancelButton}>
                        Mégse
                    </Button>
                    <Button onClick={this.handleApplyDialogConfirm} className={classes.acceptButton}>
                        Elfogadás
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    applySuccessDialog = () => {
        const {classes} = this.props

        return (
            <Dialog
                open={this.state.openApplySuccessDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleApplySuccessDialogClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent classes={{root: classes.dialogImgContent}}>
                    <img className={classes.dialogImg} src="images/done_illustration.png"/>
                </DialogContent>

                <DialogTitle id="alert-dialog-slide-title"
                             classes={{root: classes.dialogTitle}}
                             disableTypography={true}>
                    Sikeres jelentkezés!
                </DialogTitle>
                <DialogActions classes={{root: classes.dialogActionsCenter}}>
                    <Button onClick={this.handleApplySuccessDialogClose} className={classes.acceptButton}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    cancelOfferDialog = () => {
        const {classes} = this.props

        return (
            <Dialog
                open={this.state.openCancelDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleCancelDialogClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent classes={{root: classes.dialogImgContent}}>
                    <img className={classes.dialogImg} src="images/reject_illustration.png"/>
                </DialogContent>

                <DialogTitle id="alert-dialog-slide-title"
                             classes={{root: classes.dialogTitle}}
                             disableTypography={true}>
                    Műszak elutasítása
                </DialogTitle>
                <DialogContent classes={{root: classes.dialogTextContent}}>
                    <DialogContentText id="alert-dialog-slide-description" classes={{root: classes.dialogText}}>
                        Valóban elutasítod ezt a műszakot?
                    </DialogContentText>
                </DialogContent>
                <DialogActions classes={{root: classes.dialogActions}}>
                    <Button onClick={this.handleCancelDialogClose} className={classes.cancelButton}>
                        Mégse
                    </Button>
                    <Button onClick={this.handleCancelDialogConfirm} className={classes.acceptButton}>
                        Elutasítom
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    cancelSuccessDialogToggle = () => {
        this.setState({openCancelSuccessDialog: !this.state.openCancelSuccessDialog})
    }

    cancelSuccessDialog = () => {
        const {classes} = this.props

        return (
            <Dialog
                open={this.state.openCancelSuccessDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.cancelSuccessDialogToggle}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent classes={{root: classes.dialogImgContent}}>
                    <img className={classes.dialogImg} src="images/delete_illustration.png"/>
                </DialogContent>

                <DialogTitle id="alert-dialog-slide-title"
                             classes={{root: classes.dialogTitle}}
                             disableTypography={true}>
                    Sikeres műszak törlés!
                </DialogTitle>
                <DialogActions classes={{root: classes.dialogActionsCenter}}>
                    <Button onClick={this.cancelSuccessDialogToggle} className={classes.acceptButton}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    errorDialogToggle = () => {
        this.setState({openErrorDialog: !this.state.openErrorDialog})
    }

    errorDialog = () => {
        const {classes} = this.props

        return (
            <Dialog
                open={this.state.openErrorDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.cancelSuccessDialogToggle}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent classes={{root: classes.dialogImgContent}}>
                    <img className={classes.dialogImg} src="images/error_illustration.png"/>
                </DialogContent>

                <DialogTitle id="alert-dialog-slide-title"
                             classes={{root: classes.dialogTitle}}
                             disableTypography={true}>
                    Hiba történt!
                </DialogTitle>
                <DialogContent classes={{root: classes.dialogTextContent}}>
                    <DialogContentText id="alert-dialog-slide-description" classes={{root: classes.dialogText}}>
                        {this.state.errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions classes={{root: classes.dialogActionsCenter}}>
                    <Button onClick={this.errorDialogToggle} className={classes.acceptButton}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    loader = () => (
        <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )


    renderSelectedView = () => {
        const {cardView} = this.state

        if (cardView) {
            return this.renderCardView()
        }

        return this.renderMonthView()
    }

    renderCardView = () => {
        return (
            <InfiniteScroll
                dataLength={Object.keys(this.state.schedules).length}
                next={this.loadMoreCards}
                hasMore={this.state.hasMoreCards}
                loader={this.loader()}
                //refreshFunction={this.loadMoreCards}
            >
                {this.renderCards()}
            </InfiniteScroll>

        )
    }

    renderMonthView = () => {

        return (
            <InfiniteScroll
                dataLength={Object.keys(this.state.months).length}
                next={this.loadMonths}
                hasMore={true}
                loader={this.loader()}
                //refreshFunction={this.loadMoreCards}
            >
                {this.renderMonths()}
            </InfiniteScroll>

        )
    }

    loadMonths = () => {
        let token = this.state.token
        let url = this.state.nextMonthsUrl
        axios.get(url, {headers: {Authorization: token}}).then((response) => {
            let responseData = response.data

            let months = Object.assign(this.state.months, responseData.months)

            this.setState({months: months})

            //this.setState({user: responseData.user})
            this.setState({nextMonthsUrl: responseData.pagination.nextMonthsUrl})
            this.setState({hasMoreCards: responseData.pagination.hasMorePage})
        }).catch(function (error) {
            if (error.response.status === 401) {
                window.postMessage('logout')
            }
        })
    }

    renderMonths = () => {
        let cards = []
        let renderedWeeks = []

        let lastDay
        const {months} = this.state
        let today = moment().format('YYYY-MM-DD')

        const {classes} = this.props
        Object.keys(months).map(function (monthKey) {
            let month = months[monthKey]
            let firstDay
            let renderedDays = []
            let daysCount = 1

            Object.keys(month).map(function (dayKey) {
                let momentDay = moment(dayKey)
                let day = month[dayKey]
                if (!firstDay) {
                    firstDay = day.dayOfWeek

                    for (let i = 7 - firstDay; i < 6; i++) {
                        daysCount++
                        renderedDays.push(
                            <div className={classes.monthDayOfWeek}>

                            </div>
                        )
                    }
                }

                let dayOfWeek = dayKey.split('-')
                let isToday = dayKey === today
                let dayImg = ''

                if (day.info) {
                    if (day.info.shift !== null) {
                        switch (day.info.shift) {
                            case 0:
                                dayImg = (<img src='/images/mini-am-icon.svg'/>)
                                break
                            case 1:
                                dayImg = (<img src='/images/mini-pm-icon.svg'/>)
                                break
                            case 2:
                                dayImg = (<img src='/images/mini-night-icon.svg'/>)
                                break
                        }

                    } else {
                        dayImg = day.info.type
                    }
                }

                renderedDays.push(
                    <div className={classNames({[classes.monthDayOfWeek]: true, [classes.monthToday]: isToday})}>
                        <span>{dayOfWeek[2]}</span>
                        <span className={classes.monthDayText}> {dayImg} </span>
                    </div>
                )

                let isLastDay = false

                let positionOfDay = 0
                Object.keys(month).find(function (key) {
                    positionOfDay++
                    if (key === dayKey) {
                        return true
                    }
                })

                if (Object.keys(month).length === positionOfDay) isLastDay = true

                if (daysCount === 7 || isLastDay) {

                    if (isLastDay) {
                        for (let i = 7 - daysCount; i < 6; i++) {
                            renderedDays.push(
                                <div className={classes.monthDayOfWeek}>

                                </div>
                            )
                        }
                    }

                    daysCount = 0

                    renderedWeeks.push(
                        <div className={classes.monthWeek}>
                            {renderedDays}
                        </div>)

                    if (!isLastDay) {
                        renderedWeeks.push(
                            <Divider className={classes.monthDivider}/>
                        )
                    }

                    renderedDays = []

                }

                lastDay = dayKey

                daysCount++

            })

            for (let i = 7 - firstDay; i < 6; i++) {
                daysCount++
                renderedDays.push(
                    <div className={classes.monthDayOfWeek}>

                    </div>
                )
            }

            let monthHeader = new Intl.DateTimeFormat('hu-HU', {year: 'numeric', month: 'long'}).format(new Date(lastDay))
            cards.push(
                <div>
                    <h3>
                        {monthHeader}
                    </h3>
                </div>
            )

            cards.push(
                <Card className={classNames({[classes.container]: true, [classes.monthContainer]: true})}>
                    <CardContent className={classes.monthCardContent}>
                        <div className={classes.monthDays}>
                            <span className={classes.monthDay}>H</span>
                            <span className={classes.monthDay}>K</span>
                            <span className={classes.monthDay}>Sz</span>
                            <span className={classes.monthDay}>Cs</span>
                            <span className={classes.monthDay}>P</span>
                            <span className={classes.monthDay}>Szo</span>
                            <span className={classes.monthDay}>V</span>
                        </div>

                        <Divider className={classes.monthDivider}/>

                        {renderedWeeks}

                    </CardContent>
                </Card>)

            renderedWeeks = []
        })

        return cards
    }

    setView = () => {
        const {cardView} = this.state
        this.setState({cardView: !cardView})
    }

    render() {
        const {isLoading, cardView} = this.state
        const {classes} = this.props
        return (
            <MuiThemeProvider theme={theme}>
                <div>
                    <div className={classes.wallHeader}>
                        <h1>
                            Műszakok
                        </h1>
                        <div className={classes.viewSelector} onClick={this.setView}>
                            <FontAwesomeIcon icon="calendar-day" className={classNames({
                                [classes.leftSelector]: true,
                                [classes.activeSelector]: cardView
                            })}/>
                            <FontAwesomeIcon icon="calendar-alt" className={classNames({
                                [classes.rightSelector]: true,
                                [classes.activeSelector]: !cardView
                            })}/>
                        </div>
                    </div>
                    {this.renderSelectedView()}
                    {this.applyOfferDialog()}
                    {this.applySuccessDialog()}

                    {this.cancelOfferDialog()}
                    {this.errorDialog()}
                </div>
            </MuiThemeProvider>

        )
    }
}

export default withStyles(styles)(Wall)


// WEBPACK FOOTER //
// ./resources/js/components/Wall.js